module.exports = __webpack_public_path__ + "img/icon.f3a2ca41.png";